import React, {useState,useEffect} from 'react';
import { Card, Row, Col, Typography } from 'antd';
// import { useBreakpoint } from 'antd/lib/grid/hooks';
import { ArrowUpOutlined, StockOutlined, RiseOutlined } from '@ant-design/icons'; // Replace with the appropriate icon
import { Grid } from "@mui/material";
import {useGetTodayDegreeDayQuery, useGetTodayCumulativeDegreeDayQuery } from 'api/degreeDaysApi';
import { useParams } from "react-router";

const SummaryCards = () => {
  const { pestId, pestName, cropId,cropName, stationId } = useParams();
  const degreeDayQuery = useGetTodayDegreeDayQuery({
    pestId: pestId,
    stationId: stationId,
  });
  const {
    data: todayDegreeDayQueryData,
    status: todayDegreeDayQueryStatus,
    isError: todayDegreeDayQueryIsError,
    isSuccess: todayDegreeDayQueryIsSuccess,
    isLoading: todayDegreeDayQueryIsLoading
  } = useGetTodayCumulativeDegreeDayQuery({
      pestId: pestId,
      stationId: stationId,
    });
  const [todayCDD, setTodayCDD] = useState(0);
  const [todayDegreeDay, setTodayDegreeDay] = useState(0);
  const [degreeDays, setDegreeDays] = useState([]);
  useEffect(() => {
    if (degreeDayQuery.data) {
      setDegreeDays(degreeDayQuery.data);
     }
   }, [degreeDayQuery.status]);


   useEffect(() => {
    const todayDegreeDay = todayDegreeDayQueryData?.degreeDay;
    const todayCDD = todayDegreeDayQueryData?.cumulativeDegreeDay;
    
      setTodayDegreeDay(`${todayDegreeDay}`);
     setTodayCDD(`${todayCDD}`);


  },[todayDegreeDayQueryData]);


  if(todayDegreeDayQueryIsLoading){
    return <></>
  }
  return (
    <Grid container spacing={5}>
       <Grid item xs={24} sm={12} md={12} lg={6} xl={6}>
        <Card 
          bordered={false}
          style={{
            borderRadius: '8px', 
          }}
        >
                <span style={{
                    display: 'inline-flex', 
                    alignItems: 'center', 
                    justifyContent: 'center', 
                    width: '40px', 
                    height: '40px', 
                    borderRadius: '50%', 
                    backgroundColor: 'rgba(0, 227, 150, 0.1)', 

                    marginRight: '10px', 
                }}>
                   <StockOutlined style={{ color: '#00E396', fontSize: '20px', }} /> 
                </span>
            
             <div>
            <p style={{ fontSize: '24px', fontWeight: 'bold', marginBottom: '4px' }}>{todayCDD !== null && todayCDD !== undefined ? todayCDD : 'No data'}</p>
           
          </div>
          <div style={{ marginBottom: '10px' }}>
    <p style={{ fontSize: '16px', color: 'gray', fontWeight: '300' }}>Today's Cummulative Degree Day</p>
</div>
          
       
        </Card>
    </Grid>
    <Grid item xs={24} sm={12} md={12} lg={6} xl={6}>
        <Card 
          bordered={false}
          style={{
            borderRadius: '8px', 
          }}
        >
                <span style={{
                    display: 'inline-flex',
                    alignItems: 'center', 
                    justifyContent: 'center', 
                    width: '40px', 
                    height: '40px',
                    borderRadius: '50%',
                    backgroundColor: 'rgba(29, 161, 242, 0.1)', 
                    marginRight: '10px', 
                }}>
                   <RiseOutlined style={{ color: '#1890ff', fontSize: '20px', }} /> 
                </span>
            
             <div>
            <p style={{ fontSize: '24px', fontWeight: 'bold', marginBottom: '4px' }}>{todayDegreeDay !== null && todayDegreeDay !== undefined ? todayDegreeDay : 'No data'}
            </p>
           
          </div>
          <div style={{ marginBottom: '10px' }}>
    <p style={{ fontSize: '16px', color: 'gray', fontWeight: '300' }}>Today's Degree Day</p>
</div>

        </Card>
    </Grid>
    {/* Repeat for the second card */}
</Grid>
);
};

export default SummaryCards;
